import { TrackingStoreType } from "UidispatcherApiModule";
const { TrackingStore }: { TrackingStore: TrackingStoreType } =
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export default TrackingStore;
